import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider, App as AntdApp } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Theme } from "./theme/theme";
import ScrollToTop from "./utils/scrollToTop";
import { PaymentProvider } from "./contexts/payment";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
    mutations: {
      retry: 0,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const theme = {
  token: { colorPrimary: "#56613c", fontFamily: "Questrial" },
  components: { Table: { headerBg: "#F5F8FA" } },
};

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={theme}>
        <Theme>
          <AntdApp notification={{ placement: "top" }}>
            <BrowserRouter>
              <PaymentProvider>
                <ScrollToTop />
                <App />
              </PaymentProvider>
            </BrowserRouter>
          </AntdApp>
        </Theme>
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
